var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"c-button",class:{
    'c-button--loading': _vm.isLoading,
  },attrs:{"disabled":_vm.disabled,"tabindex":_vm.isLoading ? -1 : null,"aria-disabled":_vm.isLoading},on:{"click":_vm.handleClick}},[_vm._t("default"),_c('transition',{attrs:{"name":"a-button__loading"}},[(_vm.isLoading)?_c('span',{staticClass:"c-button__loadingSpinner"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }